import { ColumnResolver, OverflowCell } from "@repo/design-system/components/grids";

export const WithOverflow = (renderer, col) => (rowData) => {
    const content = renderer(rowData);
    const value = ColumnResolver(col)(rowData);
    if (!content) return content;

    const tooltipId = `tt-${col.field}-${String(rowData.id ?? "").replace(/[^a-zA-Z0-9_-]/g, "_")}`;

    return (
        <div className="cell-wrapper">
            <OverflowCell value={String(value)} tooltipId={tooltipId}>
                {content}
            </OverflowCell>
        </div>
    );
};